import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

export class LoadWidgetHelper {
    static setPreferences(
        state: Record<string, unknown>,
        action: PayloadAction<{ key: string; value: unknown }>
    ): void {
        if (action.payload.key === 'isAutomated') {
            state['secondary'] = [];
        }
        state[action.payload.key] = action.payload.value;
    }

    static addExtraReducers(builder: ActionReducerMapBuilder<Record<string, unknown>>): void {
        builder.addCase('widgetConfiguration/toggleDeviceLinkMode', (state) => {
            state.secondary = [];
            state.selectedNodes = [];
        });
        builder.addCase<string, PayloadAction<{ reset?: boolean }>>(
            'widgetConfiguration/setWidgetDevice',
            (state, action: PayloadAction<{ reset?: boolean }>) => {
                if (action.payload.reset) {
                    state.secondary = [];
                }
            }
        );
        builder.addCase('widgetConfiguration/setWidgetSource', (state) => {
            state.secondary = [];
        });
    }
}
